const SESSION_ONCE_PREFIX = 'noddi-session-once:';

const memory = new Set<string>();

export function sessionOnceKey(suffix: string): string {
  return `${SESSION_ONCE_PREFIX}${suffix}`;
}

export function isClaimed(key: string): boolean {
  if (memory.has(key)) {
    return true;
  }
  try {
    return sessionStorage.getItem(key) === '1';
  } catch {
    return false;
  }
}

export function markClaimed(key: string): void {
  memory.add(key);
  try {
    sessionStorage.setItem(key, '1');
  } catch {
    // Private mode — in-memory guard only for this tab session.
  }
}

export function clearClaim(key: string): void {
  memory.delete(key);
  try {
    sessionStorage.removeItem(key);
  } catch {
    // Private mode / blocked storage.
  }
}
